﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type UpdateCode = { type: "updateCode"; code: string };
type NavigateNextPage = { type: "navigateNextPage" };

export type ResetPageViewAction = UpdateCode | NavigateNextPage;

interface ResetPageState {
    code: string;
    navigating: boolean;
    isValid: boolean;
}

export function reducer<T>(
    state: ResetPageState,
    action: ResetPageViewAction
): ResetPageState {
    switch (action.type) {
        case "updateCode": {
            return {
                ...state,
                code: action.code,
                isValid: action.code.length == 6,
            };
        }
        case "navigateNextPage": {
            return { ...state, navigating: state.isValid };
        }
    }
}
